import React from 'react';
import {
  CapaPcbServiceType,
  CapaQuotationServiceType,
  FetchRfqPartnersQuery,
  CapaQuotationUserRfqDetail
} from '@generated/graphql';
import RfqFilesThumbnailViewer from '@routes/Common/RfqFilesThumbnailViewer';
import DrawingFilesPermissionPresenter from './DrawingFilesPermissionPresenter';
import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

interface UseStylesProps {
  matches?: boolean;
}

const useStyles = makeStyles(() => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center'
    },
    content: {
      maxWidth: (props: UseStylesProps) => (props.matches ? '100%' : 600),
      width: (props: UseStylesProps) => (props.matches ? '100%' : 600),
      backgroundColor: colorSet.gray000,
      '&.gutter': {
        padding: (props: UseStylesProps) => (props.matches ? 0 : 24)
      }
    }
  };
});

interface Props {
  matches?: boolean;
  isChat?: boolean;
  data?: CapaQuotationUserRfqDetail;
  rfqPartnersData?: FetchRfqPartnersQuery;
  onAllowRfqDrawingFileDownload: (
    quotationPartnerId: string,
    permission: boolean,
    organizationName: string
  ) => void;
}

const DrawingFilesManagementPresenter: React.FC<Props> = ({
  matches,
  data,
  rfqPartnersData,
  onAllowRfqDrawingFileDownload
}) => {
  const classes = useStyles({ matches });
  const serviceType = data?.serviceType;

  const isDesign =
    serviceType === CapaQuotationServiceType.Design ||
    (data?.pcb?.services ?? []).some(
      (service) => service.serviceType === CapaPcbServiceType.CircuitDesign
    );

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <RfqFilesThumbnailViewer matches={matches} data={data} />
      </div>
      <div className={classes.content + ' gutter'}>
        <DrawingFilesPermissionPresenter
          rfqDetail={data}
          publicOpen={data?.publicOpen ?? false}
          matches={matches}
          rfqPartnersData={rfqPartnersData}
          onAllowRfqDrawingFileDownload={onAllowRfqDrawingFileDownload}
          isDesign={isDesign}
        />
      </div>
    </div>
  );
};

export default DrawingFilesManagementPresenter;
